import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'purchase-error',
  templateUrl: './phone-purchase-error.component.html'
})
export class PhonePurchaseErrorComponent {
  public errorMsg: string;
  public goBackMsg: string;
  public continueMsg: string;

  constructor(public dialogRef: MatDialogRef<PhonePurchaseErrorComponent>) {}
}
